import { useRole } from "@/hooks/useRole";

/**
 * Role-based access control for the Runtime health admin area.
 *
 * - `canTriage`  — acknowledge / resolve / reopen incidents and edit triage notes.
 *                  Granted to moderators and admins (mirrors the
 *                  "Moderators triage frontend error incidents" RLS policy).
 * - `canConfigure` — create/delete incidents, edit notification recipients,
 *                  alert settings and regression routing rules. Admins only
 *                  (mirrors the "Admins manage …" RLS policies).
 *
 * The database policies are the real guard; these flags keep the UI honest so
 * users never see a control that would fail with a permission error.
 */
export function useRuntimeHealthAccess() {
  const { isAdmin, isModerator, loading } = useRole();
  return {
    loading,
    canTriage: isModerator || isAdmin,
    canConfigure: isAdmin,
  };
}
